import { useEffect, useState } from 'react';

import { StatsigFeatureKeys } from '@atlassian/bitbucket-features';

import { useStatsigGate } from 'src/contexts/feature-provider';
import { captureExceptionWithTags } from 'src/utils/sentry';

export const useCaptureSentryException = (error?: Error): string => {
  const [sentryId, setSentryId] = useState<string>('');

  const isSentryIdEnabled = useStatsigGate(
    StatsigFeatureKeys.bbcSentryIdsInErrorUiM1
  );

  useEffect(() => {
    (async () => {
      if (error) {
        const id = await captureExceptionWithTags(error as Error, {
          visibleToUser: isSentryIdEnabled.toString(),
        });
        if (isSentryIdEnabled) {
          setSentryId(id);
        }
      }
    })();
  }, [error, isSentryIdEnabled]);

  return sentryId;
};
